import { render, staticRenderFns } from "./SelectSubCategories.vue?vue&type=template&id=539bc99b"
import script from "./SelectSubCategories.vue?vue&type=script&lang=ts"
export * from "./SelectSubCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports